// src/registries/log-fields.ts
var LOG_FIELDS = {
  // request lifecycle (OTel HTTP semconv)
  HTTP_METHOD: "http.request.method",
  HTTP_STATUS_CODE: "http.response.status_code",
  HTTP_DURATION_MS: "http.server.request.duration",
  URL_PATH: "url.path",
  CLIENT_ADDRESS: "client.address",
  USER_AGENT: "user_agent.original",
  PROTOCOL_VERSION: "network.protocol.version",
  /** errors / exceptions (OTel exception semconv). exception.* is for
   * recorded server faults (5xx) */
  EXCEPTION_TYPE: "exception.type",
  EXCEPTION_MESSAGE: "exception.message",
  EXCEPTION_STACK: "exception.stacktrace",
  /** 4xx client-error classification (OTel error.type). the low-cardinality
   * error code, not a fault */
  ERROR_TYPE: "error.type",
  /** otel event discriminator for non-http log records (business events, health
   * summaries, web vitals). follows the opentelemetry events semconv: an event
   * is identified by event.name and its payload rides in attributes. */
  EVENT_NAME: "event.name",
  /** web vitals. browser POSTs to /v1/web-vitals, api pino-logs each one with
   * these attributes, landing in the events dataset like everything else. */
  WEB_VITAL_NAME: "web_vital.name",
  WEB_VITAL_VALUE: "web_vital.value",
  WEB_VITAL_RATING: "web_vital.rating",
  WEB_VITAL_ID: "web_vital.id",
  WEB_VITAL_NAVIGATION_TYPE: "web_vital.navigation_type",
  /** transactional email lifecycle. the api pino-logs `email.sent` at send time
   * and the resend delivery webhook logs `email.delivered`/`email.bounced`/etc,
   * both keyed on the resend message id so a send and its outcome join in axiom.
   * the event kind rides in EVENT_NAME (`email.sent`, `email.delivered`, ...). */
  EMAIL_MESSAGE_ID: "email.message_id",
  EMAIL_RECIPIENT: "email.recipient",
  EMAIL_SUBJECT: "email.subject",
  /** process health. api periodic timer pino-logs these every 30s, the
   * event-based replacement for OTel HostMetrics. */
  PROC_HEALTH_EVENT_LOOP_LAG_MS: "process.event_loop_lag_ms",
  PROC_HEALTH_HEAP_USED_BYTES: "process.heap_used_bytes",
  PROC_HEALTH_CPU_PERCENT: "process.cpu_percent",
  /** total time the event loop was blocked running GC during the sample
   * window. early-warning signal for memory pressure: V8 ramps up GC effort
   * before heap actually fills.
   */
  PROC_HEALTH_GC_PAUSE_MS_TOTAL: "process.gc_pause_ms_total",
  /** count of major (mark-sweep-compact) GC events in the window. minor/young
   * GCs are cheap and not tracked. high major-count == memory pressure.
   */
  PROC_HEALTH_GC_MAJOR_COUNT: "process.gc_major_count",
  /** identity (added globally by the pino mixin once requireAuth /
   * requireCompanyAuth populate the request context). lands at top level
   * of the axiom row.
   */
  REQUEST_ID: "request_id",
  TRACE_ID: "trace_id",
  SPAN_ID: "span_id",
  USER_ID: "user_id",
  COMPANY_ID: "company_id"
};
function aplField(key) {
  const name = LOG_FIELDS[key];
  return IDENTITY_FIELD_KEYS.has(key) ? `['${name}']` : `['attributes.${name}']`;
}
var IDENTITY_FIELD_KEYS = /* @__PURE__ */ new Set([
  "REQUEST_ID",
  "TRACE_ID",
  "SPAN_ID",
  "USER_ID",
  "COMPANY_ID"
]);
var APL_MSG_FIELD = "['body']";

export {
  LOG_FIELDS,
  aplField,
  APL_MSG_FIELD
};
